import { useEffect, useState } from "react";

import { IUBENDA_CONSENT_UPDATED_EVENT, checkCookieConsent, getEnvironment } from "utils";

export const useCookieConsent = (checkConsent: () => boolean = checkCookieConsent) => {
  const isAdmin = getEnvironment().admin;
  const [hasCookieConsent, setHasCookieConsent] = useState(() => isAdmin || checkConsent());

  useEffect(() => {
    const handleConsentUpdated = () => setHasCookieConsent(isAdmin || checkConsent());

    window.addEventListener(IUBENDA_CONSENT_UPDATED_EVENT, handleConsentUpdated);
    return () => window.removeEventListener(IUBENDA_CONSENT_UPDATED_EVENT, handleConsentUpdated);
  }, [checkConsent, isAdmin]);

  return hasCookieConsent;
};
